import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Solutions from "../pages/solutions/page";
import AcademicIntegration from "../pages/academic-integration/page";
import Testimonials from "../pages/testimonials/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/academic-integration",
    element: <AcademicIntegration />,
  },
  {
    path: "/testimonials",
    element: <Testimonials />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;